import { useState, useEffect, useMemo } from "react";

type InputData = {
  date_recordednow?: string;
  expense_date? : string;
  datesoldnow?: string;
  transaction_time_now? : string;
  date_expense_madenow?: string;
  occurrences: number;
  hours_selling: number;
  totals: number;
};

type OutputData = {
  month: string;
  year: string;
  occurrences_sum: number;
  hours_selling_sum: number;
  totals_sum: number;
};

const useAggregatedData = (data: InputData[]): OutputData[] => {
  const aggregatedData = useMemo(() => {
    const result: OutputData[] = [];

    data.forEach((item) => {
      const date = new Date(
        item.date_recordednow ||
        item.datesoldnow ||
        item.date_expense_madenow ||
        item.transaction_time_now ||
        item.expense_date ||
        Date.now()
      );
      const monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
      const month = monthName.charAt(0).toUpperCase() + monthName.slice(1);
      const year = date.getFullYear().toString();

      const existing = result.find((r) => r.month === month && r.year === year);
      if (existing) {
        existing.occurrences_sum += item.occurrences;
        existing.hours_selling_sum += item.hours_selling;
        existing.totals_sum += item.totals;
      } else {
        result.push({
          month: month,
          year: year,
          occurrences_sum: item.occurrences,
          hours_selling_sum: item.hours_selling,
          totals_sum: item.totals,
        });
      }
    });

    return result;
  }, [data]);

  return aggregatedData;
};


export default useAggregatedData;
